import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";
import Datetime from "react-datetime";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  UpdateInvetory,
  searchMedicationForSubProduct,
  getInventoryById,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";

class EditInventoryManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: "",
      quantityError: null,
      unit_price: "",
      unit_priceError: null,
      note: "",
      expiryDate: "",
      expiryDateError: null,
      medication: "",
      medicationError: null,
      _notificationSystem: null,
      cardHidden: true,
      value: "",
      name: "",
      medicationTitle: "",
      quantity_typeError: null,
      quantity_type: "0",
      showPerBox: false,
      quantity_per_box: "0",
      quantity_per_boxError: null,
      receivable_date: "",
      is_goods_received: 0,
      unreceived_quantity : "",
      chk_quantity: "",
      receivable_dateDisabled: "",

    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication inventory</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/inventoryList");
    }, 3000);
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var id = JSON.parse(localStorage.getItem("inventoryId"));
    // get inventory information
    getInventoryById(id, obj).then((res) => {
      var data = res.data;

      console.log(data, '<<-- data')
      const date = new Date(data.created_at);

      if (data.expiry_date == "" || data.expiry_date == null) {
        var expiry_date = "";
      } else {
        var expiry_date = new Date(data.receivable_date);
      }

      
      // const receivable_date = new Date(receivable_date);

      if (data.receivable_date == "" || data.receivable_date == null) {
        var receivable_date = "";
      }else{
        var receivable_date = new Date(data.receivable_date);
      }

      if (data.medication.quantity_type == "1") {
        this.setState({ showPerBox: true });
        this.setState({ quantity: data.quantity_per_box });
      } else {
        this.setState({ showPerBox: false });
        this.setState({ quantity: data.total_quantity });
      }

      if (data.quantity == null || data.quantity == 0){
        this.setState({ receivable_dateDisabled: "" });
      }else{
        this.setState({ receivable_dateDisabled: "disabled" });
      }

      this.setState({
        // quantity: data.data.quantity_per_box,
        unit_price: data.unit_price,
        note: data.note,
        expiryDate: expiry_date,
        medication: data.medication_id,
        medicationTitle: data.medication.title,
        quantity_type: data.quantity_type,
        quantity_per_box: data.quantity_per_box,
        is_goods_received: data.is_goods_received,
        receivable_date: receivable_date,
        unreceived_quantity:data.unreceived_quantity,
        chk_quantity: data.quantity
      });
    });
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  onSubmit = () => {
    let error = false;
    /*if(this.state.medication == "")
      {error = true
         this.setState({
          medicationError: (
              <small className="text-danger">
                Medication is required.
              </small>
            )
          })
        }else{ this.setState({ medicationError: null });} */
    /* if (this.state.expiryDate == "") {
      error = true;
      this.setState({
        expiryDateError: (
          <small className="text-danger">Expiry date is required.</small>
        ),
      });
    } else {
      this.setState({ expiryDateError: null });
    } */

    if (this.state.quantity == null || this.state.quantity == '') {
      error = true;
      this.setState({
        quantityError: (
          <small className="text-danger">Quantity is required..</small>
        ),
      });
    } else {
      this.setState({ quantityError: null });
    }

    if (this.state.unit_price == null || this.state.unit_price == '') {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Quantity is required..</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }

    if (this.state.is_goods_received == "") {
      this.setState({
        is_goods_received: 0
      });
    } 

    if (this.state.quantity_type == "0") {
      error = true;
      this.setState({
        quantity_typeError: <small className="text-danger">Quantity Type is required.</small>,
      });
    } else {
      this.setState({ quantity_typeError: null });
    }

    if (this.state.quantity_type == 1) {
      if (this.state.quantity_type == 0) {
        console.log('quantity_type');
        error = true;
        this.setState({
          quantity_typeError: <small className="text-danger">Quantity Type is required.</small>,
        });
      } else {
        this.setState({ quantity_typeError: null });
      }
    } else {
      this.setState({ quantity_per_box: "0" });
    }

    /*
        if(this.state.medication.length == 0)
      {error = true
         this.setState({
          medicationError: (
              <small className="text-danger">
                  Medication is required..
              </small>
            )
          })
        }else{ this.setState({ medicationError: null });} */

    if (!error) {
      var id = JSON.parse(localStorage.getItem("inventoryId"));
      // get inventory information
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      if (this.state.receivable_date != '') { 
        const receivable_date = new Date(this.state.receivable_date);
        var receivable_dd = ("0" + receivable_date.getDate()).slice(-2);
        var receivable_mm = ("0" + (receivable_date.getMonth() + 1)).slice(-2);
        var receivable_yyyy = receivable_date.getFullYear();
        var receivable_today = receivable_yyyy + "-" + receivable_mm + "-" + receivable_dd;
      } else {
        var receivable_today = '';
      }
      
      if (this.state.expiryDate != '') { 
        const date = new Date(this.state.expiryDate);
        var dd = ("0" + date.getDate()).slice(-2);
        var mm = ("0" + (date.getMonth() + 1)).slice(-2);
        var yyyy = date.getFullYear();
        var today = yyyy + "-" + mm + "-" + dd;
      }else{
        var today = '';
      }
     
      UpdateInvetory(
        this.state.medication,
        this.state.quantity,
        today,
        this.state.unit_price,
        this.state.note,
        receivable_today,
        this.state.is_goods_received,
        this.state.quantity_type,
        this.state.quantity_per_box,
        obj,
        id
      )
        .then((res) => {
          if (res.data.success === false) {
            this.handleClick("bl");
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              title: "",
              description: "",
              brand: "",
              size: "",
            });
          }
          // this.props.history.push('/admin/subscription');
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim());
      }, 500),
    });
  };
  sendToParent = async (name) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));

      const obj = token.token;

      await searchMedicationForSubProduct(this.state.name, obj).then((res) => {
        var mdata = res.data.data;

        var medicationItems = [];

        //alert("in else")
        this.setState({ medication_detail: [] });

        res.data.data.map((x, i) => {
          medicationItems.push({
            value: x.id,
            label: x.title + "(" + x.item_code + ")",
          });
        });

        this.setState({
          medicationItems: medicationItems,
        });
      });
    } else {
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  handleSelectChange = (value) => {
    this.setState({
      medication: value.value,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  handleQuantity_per_box_chnage(event) {
    this.setState({ quantity_per_box: event.target.value });
    event.target.value === ""
      ? this.setState({
        quantity_per_boxError: <small className="text-danger">Quantity per box is required.</small>,
      })
      : this.setState({ type_textError: null });
  }

  handleQuantity_type_chnage(event) {
    this.setState({ quantity_type: event.target.value });
    if (event.target.value == 1) {
      this.setState({ showPerBox: true });
    } else {
      this.setState({ quantity_per_box: "0" });
      this.setState({ showPerBox: false });
    }


    event.target.value === "0"
      ? this.setState({
        quantity_typeError: (
          <small className="text-danger">
            Quantity Type is required.
          </small>
        ),
      })
      : this.setState({ quantity_typeError: null });
  }


  handleReceivableDateChange = (date) => {
    this.setState({
      receivable_date: date,
    });
  };

  is_goods_received = (e) => {
    var checked = e.target.checked;
    if (checked == false) {
      this.setState({
        is_goods_received: checked,
        is_goods_received: 0
      });
    } else {
      this.setState({ is_goods_received: checked, is_goods_received: 1 });
    }

  }

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Items</ControlLabel>
                          <select
                            name="description"
                            style={{ textTransform: "capitalize" }}
                            disabled="disabled"
                            onChange={this.onChange}
                            value={this.state.medication}
                            className="form-control"
                          >
                            <option value="0">Select Item</option>

                            <option value={this.state.medication}>
                              {this.state.medicationTitle}
                            </option>
                          </select>

                          {this.state.medicationError}
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Quantity Type</ControlLabel>

                          <div className="order_source_data">
                            <Radio
                              number="31"
                              option="1"
                              name="quantity_type"
                              onChange={(event) => this.handleQuantity_type_chnage(event)}
                              checked={this.state.quantity_type == "1"}
                              label="Quantiy Per Box"
                              disabled={true}
                            />
                            &nbsp;
                            <Radio
                              number="32"
                              option="2"
                              name="quantity_type"
                              onChange={(event) => this.handleQuantity_type_chnage(event)}
                              checked={this.state.quantity_type == "2"}
                              label="Quantiy Per Tablet"
                              disabled={true}
                            />

                          </div>
                          {this.state.quantity_typeError}
                        </FormGroup>

                        {this.state.showPerBox == true &&
                          <FormGroup>
                            <ControlLabel>Quantity Per Box</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) => this.handleQuantity_per_box_chnage(event)}
                              required
                              readOnly
                              name="quantity_per_box "
                              value={this.state.quantity_per_box || ""}
                              placeholder="Quantity Per Box"
                              disabled={true}
                            />
                            {this.state.quantity_per_boxError}
                          </FormGroup>
                        }

                        <FormGroup>
                          <ControlLabel>Quantity</ControlLabel>
                          <FormControl
                            name="quantity"
                            value={this.state.quantity}
                            onChange={(event) => {
                              this.setState({ quantity: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    quantityError: (
                                      <small className="text-danger">
                                        quantity is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ quantityError: null });
                            }}
                            placeholder="Enter quantity"
                            type="number"
                          />
                          {this.state.quantityError}
                        </FormGroup>

                        {this.state.is_goods_received == "0" &&
                          <FormGroup>
                            <ControlLabel>Unreceived quantity</ControlLabel>
                            <FormControl
                              type="text"
                              required
                              readOnly
                              name="unreceived_quantity"
                              value={this.state.unreceived_quantity  || ""}
                              placeholder="Unreceived quantity"
                              disabled={true}
                            />
                          </FormGroup>
                        }

                        <FormGroup>
                          <ControlLabel>
                            Buying price of the stocks
                          </ControlLabel>
                          <FormControl
                            name="unit_price"
                            readOnly
                            value={this.state.unit_price}
                            onChange={(event) => {
                              this.setState({ unit_price: event.target.value });
                            }}
                            placeholder="EnterbBuying price of the stocks"
                            type="number"
                          />
                          {this.state.unit_priceError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Note</ControlLabel>
                          <textarea
                            className="form-control"
                            readOnly
                            name="note"
                            value={this.state.note}
                            cols={3}
                            rows={2}
                            placeholder="Enter note"
                            onChange={(event) => {
                              this.setState({ note: event.target.value });
                            }}

                          ></textarea>
                        </FormGroup>

                        <FormGroup>
                          <Checkbox
                            number="1"
                            checked={this.state.is_goods_received}
                            onChange={this.is_goods_received}
                            label="Is Goods Received?"
                          ></Checkbox>
                        </FormGroup>

                        
                        <FormGroup>
                          <ControlLabel>Receivable Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{ placeholder: "Receivable Date", disabled: this.state.receivable_dateDisabled }}
                            defaultValue={this.state.receivable_date}
                            closeOnSelect={true}
                            value={this.state.receivable_date}
                            onChange={this.handleReceivableDateChange}
                          />
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Expiry Date</ControlLabel>
                          <FormControl
                            name="expiryDate"
                            readOnly
                            value={this.state.expiryDate}
                            onChange={(event) => {
                              this.setState({ expiryDate: event.target.expiryDate });
                            }}
                            placeholder="Expiry Date"
                          />

                        </FormGroup>
                      </Col>
                    </Row>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EditInventoryManagement;
